import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
  code: Yup.string()
    .min(6)
    .required()
})

export { validationSchema }
